import type { QuoteProps } from './types'

export default function Quote({ quote = '', attribution = '', isPart = false }: QuoteProps) {
	const content = (
		<blockquote className="flex items-stretch border-l-2 border-brand-500 py-2 pl-5">
			<div className="flex min-w-0 flex-1 flex-col gap-8">
				<p className="text-2xl leading-8 font-medium italic text-black-950">{quote}</p>
				{attribution && (
					<cite className="body-small not-italic text-black-600">— {attribution}</cite>
				)}
			</div>
		</blockquote>
	)

	if (isPart) {
		return <div className="container my-16">{content}</div>
	}

	return <div className="my-12">{content}</div>
}
